import Typography from "@mui/material/Typography";
import { Box, Button, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { logoutUser } from "../../AuthProvider";

const logoutTitle = {
  textAlign: "center",
  fontWeight: "bold",
  color: "#004186",
  marginBottom: "18px",
};
const Logout = () => {
  const navigate = useNavigate();
  return (
    <Grid>
      <Typography sx={{ ...logoutTitle, color: "#4C4C4C" }} variant="h5">
        Want to Log Out?
      </Typography>
      <Typography sx={{ ...logoutTitle, marginBottom: "24px" }} variant="h5">
        Are you sure ?
      </Typography>
      <Box
        display={"flex"}
        flexDirection={"column"}
        width={"auto"}
        justifyContent={"center"}
        gap={"24px"}
      >
        <Button
          variant="contained"
          onClick={() => {
            logoutUser();
          }}
        >
          <Typography sx={{ fontWeight: "bold" }}>Yes, Log me Out</Typography>
        </Button>
        <Button variant="outlined" onClick={() => navigate(-1)}>
          <Typography sx={{ fontWeight: "bold", color: "#4C4C4C" }}>
            No
          </Typography>
        </Button>
      </Box>
    </Grid>
  );
};

export default Logout;
